import Vue from 'vue';
import Router from 'vue-router';
import Users from "./views/Users";
import Login from './views/Login';
import Dashboard from './views/Dashboard';
import Book from './views/Book';
import firebase from '@/config/db.js';

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: '/',
    routes: [
    {
        path: '/',
        name: 'login',
        component: Login,
        beforeEnter: (to, from, next) => {
            firebase.auth().onAuthStateChanged(user => {
                if (user) {
                    next('/dashboard');
                }else{
									next();
								}
            });
        }
    },
		{
				path: '/users',
				name: 'users',
				component: Users
		},
    {
        path: '/dashboard',
        name: 'Dashboard',
        component: Dashboard, 
				meta: {
					requiresAuth: true
				}
    },
    {
        path: '/book/:id',
        name: 'Book',
        component: Book, 
				meta: {
					requiresAuth: true
				}
    },
    {
      path: '*',
			beforeEnter() {
					window.location.href = "/";
			}
    }
]
});

  //router Guards
router.beforeEach((to, from, next) => {
  const currentUser = firebase.auth().currentUser;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  if (requiresAuth && !currentUser) next('/login');
  else if (!requiresAuth && currentUser) next('/dashboard');
  else next();
});

export default router
